/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { define, ui, s } from '@owenscorning/pcb.alpha';
import { useEffect, useState } from 'react';

import { mdms } from '../../../../../api';
import { connectURLSearchParams } from '../../../../../redux/connectors/URLSearchParamConnector';
import Modal from '../../../../Modal';
import { BasicContent } from '../../../../OC/PageBuilder/BasicContent';
import { H3, H4 } from '../../../../OC/oc-h';
import Picture from '../../../../OC/oc-picture';
import { getNewCloudinary, getCombinedImageUrl } from '../../../../OC/oc-picture-overlay';
import { Screens } from '../../../../PageBuilder/editing/Viewport';
import { imageOverlayConfig } from '../../../../Roofing/DesignAndInspire/utils/imageOverlayConfig';
import { connectLocation } from '../../../../location/LocationConnectors';
import CTA from '../../CTA';

const MainHeading = styled(H3)`
  margin-bottom: 32px;
`;

const ModalHeading = styled(H3)`
  margin-bottom: 16px;
`;

const zoomWrapperStyles = css`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  position: relative;

  img {
    width: 100%;
  }

  .fa {
    background: rgba(0, 0, 0, 0.5);
    border-right: 1px white solid;
    border-top: 1px white solid;
    bottom: 0;
    color: #fff;
    font-size: 24px;
    left: 0;
    padding: 12px;
    position: absolute;
  }
`;

const ZoomWrapper = ({ children, onClick, sb }) => (
  <div
    css={zoomWrapperStyles}
    onClick={onClick}
    data-track="zoom"
    data-track-image-name={`styleboard ${sb?.title}`}
  >
    <span className="fa fa-search-plus" />
    {children}
  </div>
);

const ImageContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(1, 1fr); // <-- 1 for mobile
  margin-bottom: 16px;
  margin-top: 0px;
  width: 100%;

  @media (min-width: 680px) {
    grid-template-columns: repeat(2, 1fr); // <-- 2 for large mobile / small tablet
  }

  @media (min-width: ${Screens.Tablet}px) {
    grid-template-columns: repeat(3, 1fr); // <-- 3 for tablet
  }

  @media (min-width: ${Screens.Desktop}px) {
    grid-template-columns: repeat(4, 1fr); // <-- 4 for desktop and above
  }

  h3 {
    font-size: 20px !important;
    margin-top: 8px;
  }
`;

const getShingleColorData = sbData => sbData?.contents?.[0]?.shingleColor?.color?.__data?.data?.shingle_colors?.[0];

const getFinalImageUrl = (shingleColorData, heroImage, shingleColorName, cloudinary) => {
  const { baseLayer, overlays } = imageOverlayConfig({
    shingleColor: shingleColorData,
    heroImage,
  });

  baseLayer.desktop.scaleSettings = { width: 1146, height: 612 };
  overlays.desktop[0].position = { x: -15, y: 100 };
  overlays.desktop[1] = {
    ...overlays.desktop[1],
    position: { x: 345, y: 45 },
    fontSize: shingleColorName?.length > 15 ? 26 : 32,
  };
  return getCombinedImageUrl({
    cld: cloudinary,
    baseLayer: baseLayer.desktop,
    overlays: overlays.desktop,
  });
};

const mapStyleBoard = (sbData, cloudinary, localeCode) => {
  const heroImage = sbData.contents?.[0]?.heroImage;
  const shingleColorData = getShingleColorData(sbData);
  const pairingTitleJoiner = localeCode?.toLowerCase().includes('fr-') ? 'et' : '&';
  const pairingTitle = `${sbData?.contents?.[0]?.colorName} ${pairingTitleJoiner} ${shingleColorData?.name}`;
  const shingleColorName = shingleColorData?.name;
  return {
    imageUrl: getFinalImageUrl(shingleColorData, heroImage, shingleColorName, cloudinary),
    route: sbData?.route,
    shingleColorLine: sbData?.contents?.[0]?.shingleColor?.line,
    shingleColorName,
    shingleColorUid: shingleColorData?.uid,
    title: pairingTitle,
  };
};

const getUniqueStyleBoardsForColor = (styleBoards, pageSlug, shingleColorUid) => {
  const uniqueStyleBoards = [];

  styleBoards
    ?.filter(styleBoard => styleBoard?.shingleColorUid === shingleColorUid)
    .forEach(styleBoard => {
      const duplicateIndex = uniqueStyleBoards.findIndex(candidate => candidate.title === styleBoard.title);

      if (duplicateIndex === -1) {
        uniqueStyleBoards.push(styleBoard);
      } else if (
        styleBoard.shingleColorLine === pageSlug &&
        uniqueStyleBoards[duplicateIndex].shingleColorLine !== pageSlug
      ) {
        uniqueStyleBoards[duplicateIndex] = styleBoard;
      }
    });

  return uniqueStyleBoards;
};

const StyleBoardsForColor = connectLocation(
  ({ name, mainHeading, bodyHeading, bodyCopy, locale, cta, modalCtaText, pageSlug, urlParams }) => {
    const [styleBoardsData, setStyleBoardsData] = useState(null);
    const [currentModalStyleBoard, setCurrentModalStyleBoard] = useState(null);
    const [cloudinary] = useState(getNewCloudinary());

    useEffect(() => {
      mdms
        .get(`/api/v2/cms/sites/www.owenscorning.com/data?dataset=color_pairing&language=${locale?.code}&type=ItemList`)
        .then(response => response.json())
        .then(responseJson => {
          setStyleBoardsData(responseJson?.data);
        });
    }, []);

    const currentShingleColorUid = urlParams['shingle-color'];
    const mappedStyleBoards = styleBoardsData?.map(sb => mapStyleBoard(sb, cloudinary, locale?.code));
    const foundStyleBoards = getUniqueStyleBoardsForColor(mappedStyleBoards, pageSlug, currentShingleColorUid);

    if (!foundStyleBoards?.length) {
      return null;
    }

    const shingleColorName = foundStyleBoards[0]?.shingleColorName;

    return (
      <>
        {mainHeading && (
          <MainHeading font="body">{mainHeading?.replace('%n', `${name} ${shingleColorName}`)}</MainHeading>
        )}
        {bodyHeading && <H4 font="body">{bodyHeading}</H4>}
        {bodyCopy && <BasicContent bodyCopy={bodyCopy} />}
        <ImageContainer>
          {foundStyleBoards?.map(sb => (
            <div key={sb.route}>
              <ZoomWrapper
                onClick={() => {
                  setCurrentModalStyleBoard(sb);
                }}
                sb={sb}
              >
                <Picture
                  source={sb?.imageUrl}
                  transform="none"
                  alt={sb?.title}
                />
              </ZoomWrapper>
              <H3 font="body">
                {sb?.title}
              </H3>
            </div>
          ))}
        </ImageContainer>
        {cta && <CTA url={cta?.url} text={cta?.text} color={cta?.color} data-track="learn more" data-track-destination={cta?.url} />}
        <Modal
          open={!!currentModalStyleBoard}
          onClose={() => {
            setCurrentModalStyleBoard(null);
          }}
          className="no-borders gallery-modal"
        >
          <img src={currentModalStyleBoard?.imageUrl} alt={currentModalStyleBoard?.title} />
          <p>Shingle Style Board</p>
          <ModalHeading>{currentModalStyleBoard?.title}</ModalHeading>
          <CTA
            url={`/${locale?.code}${currentModalStyleBoard?.route}`}
            text={modalCtaText} color="white"
            data-track="learn more"
            data-track-destination={`/${locale?.code}${currentModalStyleBoard?.route}`}
          />
        </Modal>
      </>
    );
  }
);

export const ConnectedStyleBoardsForColor = connectURLSearchParams(StyleBoardsForColor);

export default define`Style Boards for Color`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/Modules/Page/Thumbnails/StyleBoardsForColor`,
  view: ({ Board, value }) => {
    const name = [Board?.settings?.general?.prehead, Board?.settings?.general?.proper_name].join(' ').trim();
    return <ConnectedStyleBoardsForColor name={name} pageSlug={Board?.build?.slug} {...value} />;
  },
  edit: ui`Form`.of({
    mainHeading: ui`Text`({ label: 'Heading', default: 'Explore More %n' }),
    [s._]: ui`Tip`.of('Use "%n" to inject the name of the current shingle and color.'),
    bodyHeading: ui`Text`({ label: 'Body Heading', default: 'Get Inspired With Style Boards' }),
    bodyCopy: ui`Text/Rich`({ label: 'Body Copy' }),
    cta: ui`CTA`({
      label: 'Bottom CTA',
      default: {
        text: 'View All Style Boards',
        url: '/en-us/roofing/design-inspire/shingles-colors-style-boards',
        color: 'white',
      },
    }),
    modalCtaText: ui`Text`({ label: 'Modal CTA Text', default: 'View Pairing Details' }),
  }),
});
